import { render, staticRenderFns } from "./FilesNavigation.vue?vue&type=template&id=b3d7fbf2&scoped=true"
import script from "./FilesNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesNavigation.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesNavigation.vue?vue&type=style&index=0&id=b3d7fbf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d7fbf2",
  null
  
)

export default component.exports